module.exports = __webpack_public_path__ + "static/media/instagram.3a3f87f5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/footer/instagram.svg
// module id = 287
// module chunks = 0